/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const c=["freehand","hybrid","click"],e="click";export{e as defaultDrawingMode,c as drawingModes};
